import { memo } from 'react'

import { Button, Text } from '@cash-me/react-components'

import { creditComparisonRows } from './data'
import * as S from './styles'

type Props = {
  onCtaClick: () => void
}

export const CondominiumCreditLinesComparison = memo(({ onCtaClick }: Props) => (
  <S.Section aria-labelledby="condominium-credit-lines-title">
    <S.Content>
      <S.Heading>
        <Text
          id="condominium-credit-lines-title"
          as="h2"
          size="heading2"
          weight="medium"
          color="var(--colors-neutral-text-default)"
        >
          Crédito para Condomínio <S.Highlight>x rateio extraordinário</S.Highlight>
        </Text>
      </S.Heading>

      <S.Intro>
        <Text size="bodySmall" color="var(--colors-neutral-text-default)">
          Compare as duas formas de viabilizar o projeto do empreendimento e veja o que precisa ser avaliado em cada
          uma.
        </Text>
      </S.Intro>

      <S.TableScroller role="region" aria-label="Comparação entre linhas de crédito">
        <S.TableShell>
          <S.Badge>Melhor escolha</S.Badge>
          <S.TableViewport>
            <S.Table>
              <caption>Comparação entre o Crédito para Condomínio e o rateio extraordinário</caption>
              <colgroup>
                <col />
                <col />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">Comparativo</th>
                  <th scope="col">Crédito para Condomínio</th>
                  <th scope="col">Rateio extraordinário</th>
                </tr>
              </thead>
              <tbody>
                {creditComparisonRows.map(({ id, criterion, condominiumCredit, extraordinaryFee }) => (
                  <tr key={id}>
                    <th scope="row">{criterion}</th>
                    <td>{condominiumCredit}</td>
                    <td>{extraordinaryFee}</td>
                  </tr>
                ))}
              </tbody>
            </S.Table>
          </S.TableViewport>
        </S.TableShell>
      </S.TableScroller>

      <Button
        aria-label="Solicitar uma simulação de crédito para condomínio"
        size="lg"
        type="button"
        variants="text-only"
        onClick={onCtaClick}
      >
        Solicitar uma simulação
      </Button>
    </S.Content>
  </S.Section>
))

CondominiumCreditLinesComparison.displayName = 'CondominiumCreditLinesComparison'
